import { useEffect, useState } from 'react'

// Viewport tiers. Tailwind v4 defaults: md=768px, lg=1024px.
// The W1 mobile-shell switch is `<1024` (lg is the desktop boundary).
export type Breakpoint = 'sm' | 'md' | 'lg'

const MD = '(min-width: 768px)'
const LG = '(min-width: 1024px)'

function read(): Breakpoint {
  if (typeof window === 'undefined' || !window.matchMedia) return 'lg'
  if (window.matchMedia(LG).matches) return 'lg'
  if (window.matchMedia(MD).matches) return 'md'
  return 'sm'
}

/** Reactive viewport tier. SPA (no SSR) → safe to init synchronously. */
export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState<Breakpoint>(read)
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mqMd = window.matchMedia(MD)
    const mqLg = window.matchMedia(LG)
    const update = () => setBp(read())
    mqMd.addEventListener('change', update)
    mqLg.addEventListener('change', update)
    return () => {
      mqMd.removeEventListener('change', update)
      mqLg.removeEventListener('change', update)
    }
  }, [])
  return bp
}

/** True below 1024px — the single switch for the mobile shell. */
export function useIsMobile(): boolean {
  return useBreakpoint() !== 'lg'
}
